module.exports = __webpack_public_path__ + "static/media/IMG_7298_DxO.ff5e2e96.jpg";